import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia-title" className="border-b border-line bg-ink" data-id="element-115" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 lg:py-16" data-id="element-116" data-mp="9umfopvopk68">
        <div className="mx-auto flex max-w-xl flex-col items-center rounded-2xl border border-line bg-surface p-5 text-center sm:p-8" data-id="element-117" data-mp="9wphe76791qs">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-success/12" data-id="element-118" data-mp="jt26ssupotfq">
            <ShieldCheckIcon aria-hidden="true" className="h-6 w-6 text-success" data-id="element-119" data-mp="ntm3jvbdhv1c" />
          </div>

          <h2 id="garantia-title" className="mt-4 text-lg font-black leading-tight tracking-tight text-ivory sm:text-2xl" data-id="element-120" data-mp="skcdlluqum2d">
            Garantía 15 días — sin preguntas
          </h2>

          <p className="mt-4 max-w-md text-[12px] leading-relaxed text-muted sm:text-sm" data-id="element-121" data-mp="12k365hzquqzt">
            Usás el Protocolo C.A.L.M.A. en el próximo conflicto. Si en 15 días no ves menos
            conflictos o mejor comunicación:
          </p>

          <p className="mt-4 text-xl font-black leading-tight tracking-tight text-success sm:text-2xl" data-id="element-122" data-mp="25pkijlpwdbab">
            devolución del 100%
            <span className="mt-1 block text-[12px] font-bold text-ivory sm:text-sm" data-id="element-123" data-mp="1vt7sqyxh3hku">
              sin formularios, sin drama.
            </span>
          </p>

          <p className="mt-4 text-[11px] font-semibold text-muted" data-id="element-124" data-mp="1ruifr7gck21q">
            Tasa de devoluciones: menos del 1%.
          </p>

          <p className="mt-5 max-w-md rounded-xl border border-accent/40 bg-surfaceAlt px-4 py-3 text-[11px] leading-relaxed text-ivory" data-id="element-125" data-mp="2jitp7emgnip5">
            <span className="font-bold text-accent" data-id="element-126" data-mp="2er26fq9jqh9k">Método 12 Semanas:</span> si en la semana 4 no
            ves cambios verificables, devolvemos el 100%.
          </p>
        </div>
      </div>
    </section>;
}